import { gql } from '@apollo/client';

export const fetchCloudSiteOrders = gql`
  query fetchCloudSiteOrders($cloudSiteId: String!, $searchOptions: ConnectionSearchOptions) {
    cloudSiteOrders(cloudSiteId: $cloudSiteId, searchOptions: $searchOptions) {
      totalCount
      pageInfo {
        endCursor
        hasNextPage
      }
      nodes {
        id
        orderNumber
        billingContactEmail
        created
        contextSubject
        metadata {
          supportTicketNumber
        }
        metadataObj {
          supportTicketNumber
          handNote
          termsOfTransfer
          reasonCode
          newBillingAdmin
          currentBillingAdmin
        }
        contextSubjectId
        orderLineItems {
          nodes {
            lineItemId
            quantity
            type
            skipTrial
            promotions {
              id
              title
              status
              benefits {
                subBenefitType
                value
                iterations
                duration
                benefitType
              }
              promotionWindow {
                endTime
                startTime
              }
            }
            offering {
              id
              name
            }
            pricingPlan {
              id
              type
              billingFrequency
            }
            orderTransitionType
            salesTransitionType
            edition
            entitlementId
            entitlementNumber
            parentEntitlementId
            productName
            productId
            orderLineItemsPurchaseMetadata {
              fieldName
              fieldValue
            }
            orderLineItemsAccountModification {
              accountModificationTransactionAccountId
              accountModificationInvoiceGroupId
            }
          }
        }
      }
    }
  }
`;
